import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (~600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-33">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 pointer-events-none" data-id="element-34">
          <div className="bg-[#1A1A1A]/95 backdrop-blur-md border-t border-white/10 py-3 px-4 sm:px-6 pointer-events-auto" data-id="element-35">
            <div className="max-w-3xl mx-auto flex items-center justify-between gap-4" data-id="element-36">
              <div className="hidden sm:flex items-center gap-3 text-white" data-id="element-37">
                <span className="text-2xl font-serif font-bold" data-id="element-38">$6.36</span>
                <span className="text-sm text-gray-400 line-through" data-id="element-39">$19</span>
                <span className="text-xs text-[#1B6B3A] font-semibold bg-[#1B6B3A]/20 px-2 py-0.5 rounded" data-id="element-40">
                  Save 66%
                </span>
              </div>
              <a href="#pricing" onClick={e => {
            e.preventDefault();
            const target = document.getElementById('pricing');
            if (!target) return;
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - 80;
            const startPosition = window.scrollY;
            const distance = targetPosition - startPosition;
            const duration = 1200;
            let start: number | null = null;
            function step(timestamp: number) {
              if (!start) start = timestamp;
              const progress = Math.min((timestamp - start) / duration, 1);
              const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
              window.scrollTo(0, startPosition + distance * ease);
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          }} className="group w-full sm:w-auto bg-[#1B6B3A] hover:bg-[#165930] text-white text-base sm:text-lg font-bold py-3 px-6 sm:px-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-41">
                <span data-id="element-42">Get Closing Number Lock</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-43" />
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}